/* eslint-disable parog-web/no-glint-expect-error-directive */
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import perform from 'ember-concurrency/helpers/perform';
import and from 'ember-truth-helpers/helpers/and';
import not from 'ember-truth-helpers/helpers/not';
import or from 'ember-truth-helpers/helpers/or';
import FileAttachmentDownloader from 'parog-web/components/file-attachment-downloader';
import FileDownloadAndVisualisation from 'ui-kit/components/file-download-and-visualisation';

interface Args {
  mimeType: string;
  alternativeText: string;

  documentContent?: string;
  isRunning: boolean;

  fileName?: string;
  shouldDisplayDownloadLink?: boolean;
  shouldDisplayTextWithDownloadIcon?: boolean;
  downloadText?: string;
  documentUrl?: string;
}

export default class FileDisplayer extends Component<Args> {
  get isRunning() {
    return (
      this.args.isRunning ||
      !(this.args.documentContent || this.args.documentUrl)
    );
  }

  get linkSource() {
    if (this.args.documentUrl) return this.args.documentUrl;

    return `data:${this.args.mimeType};base64,${this.args.documentContent}`;
  }

  <template>
    {{#unless this.isRunning}}
      {{! Without @shouldDisplayDownloadLink, only touch screens display the download button }}
      {{! prettier-ignore }}
      <FileAttachmentDownloader as |d|>
        <div class='field mt16 {{unless @shouldDisplayDownloadLink "hidden [@media(pointer:coarse)]:block"}}'>
            {{! @glint-expect-error }}
          {{#if d.downloadFileFromContentTask.isRunning}}
            <div class='ui active mini loader inline'></div>
          {{else}}
            <button
              type='button'
            {{! @glint-expect-error }}
              class='ui pink tertiary icon button {{if d.downloadFileFromContentTask.isRunning "loading"}}'
              data-test-file-link
            {{! @glint-expect-error }}
              {{on 'click' (perform d.downloadFileFromContentTask
                  this.linkSource
                  @mimeType
                  (or @fileName 'document')
                )
              }}
            >
              <i class='file icon'></i>
              Télécharger le fichier
            </button>
          {{/if}}
        </div>
      </FileAttachmentDownloader>
      {{#if
        (and
          @shouldDisplayTextWithDownloadIcon (not @shouldDisplayDownloadLink)
        )
      }}
        {{! prettier-ignore }}
        <FileAttachmentDownloader as |d|>
          <div class="flex justify-between [@media(pointer:coarse)]:hidden">
            {{@downloadText}}
            <i
              role='button'
              data-html2canvas-ignore
              class='icon download semeia primary-color cursor-pointer'
              {{! @glint-expect-error }}
              {{on 'click' (perform d.downloadFileFromContentTask
                  this.linkSource
                  @mimeType
                  (or @fileName 'document')
                )
              }}
            ></i>
          </div>
        </FileAttachmentDownloader>
      {{/if}}
    {{/unless}}
    <div class='field mb16'>
      <FileDownloadAndVisualisation
        @mimeType={{@mimeType}}
        @isRunning={{this.isRunning}}
        @alternativeText={{@alternativeText}}
        @src={{this.linkSource}}
      />
    </div>
  </template>
}
